import { render, staticRenderFns } from "./SentMail.vue?vue&type=template&id=c75c5fa0&"
import script from "./SentMail.vue?vue&type=script&lang=js&"
export * from "./SentMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports